import React, { useEffect } from 'react';

import { useCurrentUser } from '~/src/common/user';
import { useLocale } from '~/src/components/LocaleProvider';

import { useYouboraAnalitics } from './YouboraAnaliticsProvider';
import { useMediaPlayer } from '../MediaPlayerProvider';
import { useMediaSourceDetails } from '../useMediaSourceDetails';

/**
 * General youbora settings for all medias
 * to provide individual media meta information create additional components and use 'setVideoOptions' to provide details
 */
export const CommonYouboraAnalytics: React.FC = () => {
  const { plugin } = useYouboraAnalitics();
  const { player, mediaId } = useMediaPlayer();
  const { currentUser } = useCurrentUser();
  const mediaDetails = useMediaSourceDetails();
  const { locale } = useLocale();

  useEffect(() => {
    if (player !== null && plugin !== null) {
      /**
       * - Analytics options are global settings that control how and which data is gathered, for all video sessions.
       * - Video options are settings that apply exclusively to individual video sessions
       * see for more details https://documentation.npaw.com/integration-docs/docs/plugin-integration#difference-between-analytics-options-and-video-options
       */
      plugin?.setAnalyticsOptions({
        'user.name': currentUser?.id,
        'app.name': 'web',
      });
    }
  }, [currentUser?.id, locale, mediaDetails, mediaId, player, plugin]);

  return null;
};
